<svelte:head>

    <link rel="stylesheet" type="text/css" href="/global.css" />
    <link rel="stylesheet" type="text/css" href="/css/forms.css" />

</svelte:head>

<script>

    import { createEventDispatcher } from "svelte";
    import { fade } from 'svelte/transition';

    import IntegrationPreview from "../integrations/integrationpreview.svelte";
    import Tripadvisor from "../integrations/tripadvisor.svelte";
    import Google from "../integrations/google.svelte";
    import Facebook from "../integrations/facebook.svelte";

    import {
        errorReasons
    } from "../api.svelte";


    const dispatch = createEventDispatcher();

    export let propertyId = false;
    export let propertyData = false;
    export let currentView = 'integrations';
    export let integrationsError = false;
    export let showSubtitle = false;
    export let showButton = false;
    export let isSuccessful = false;

    $: getNumIntegrations = () => {

        if (!propertyData) return 0;

        return Object.keys(propertyData['integrations']).length;

    };

    $: getMaxIntegrations = () => {

        if (!propertyData) return '∞';

        if (propertyData['maxintegrations'] === 'unlimited') {

            return '∞';
        }

        return propertyData['maxintegrations'];

    };

    $: hasIntegration = (id) => {

        if (!propertyData) return false;

        return Object.keys(propertyData['integrations']).includes(id)
            && Object.keys(propertyData['integrations'][id]).includes('name');

    };

    $: getIntegrationStatus = (id) => {

        return (hasIntegration(id)) ? 'linked': 'unlinked';
    };

    $: getIntegrationData = (id) => {

        return (hasIntegration(id)) ? propertyData['integrations'][id] : {};
    };

    $: getIcon = (id) => {

        return `/images/icons/integrations/${id}.svg`;
    };


    const onViewChanged = (evt) => {

        dispatch('view', {
            id: evt.detail['id']
        });

    };

    const onClosed = (evt) => {

        dispatch('view', {
            id: 'integrations'
        });

    };

    const onSubmitted = () => {

        if (!showButton) return;

        dispatch('submitted');

    };

    const onIntegrationClicked = (evt) => {

        dispatch('clicked', {
            id: evt.detail['id']
        });

    };

    const onIntegrationDeleted = (evt) => {

        dispatch('deleted', {
            integration: evt.detail['integration']
        });

    };

    const onTripadvisorSelected = (evt) => {

        dispatch('selected', {
            id: 'tripadvisor',
            details: {
                name: evt.detail['name'],
                address: evt.detail['address'],
                url: evt.detail['url']
            }
        });

    };

    const onGoogleSelected = (evt) => {

        dispatch('selected', {
            id: 'google',
            details: {
                id: evt.detail['id'],
                placeId: evt.detail['placeId'],
                name: evt.detail['name'],
                address: evt.detail['address'],
                account: evt.detail['account']
            }
        });

    };

    const onFacebookSelected = (evt) => {

        dispatch('selected', {
            id: 'facebook',
            details: {
                id: evt.detail['id'],
                token: evt.detail['token'],
                name: evt.detail['name']
            }
        });

    };

</script>


{#if currentView === 'integrations'}

    <form on:submit|preventDefault={() => onSubmitted()} id="integrationsform" class="forms">

        <div id="formtitle">

            Integrationen ({getNumIntegrations()}/{getMaxIntegrations()})

        </div>

        {#if showSubtitle}

            <div id="formsubtitle">

                {#if propertyData}

                    {propertyData['details']['name']}

                {/if}

            </div>

        {/if}

        {#if integrationsError}

            <div transition:fade id="error">

                {errorReasons[integrationsError]}

            </div>

        {/if}

        <div class="integrations">

            <IntegrationPreview
                    id="tripadvisor"
                    icon={getIcon('tripadvisor')}
                    name="TripAdvisor"
                    linkStatus={getIntegrationStatus('tripadvisor')}
                    linkText="TripAdvisor verknüpfen"
                    data={getIntegrationData('tripadvisor')}
                    on:clicked={onIntegrationClicked}
            />

            <IntegrationPreview
                    id="google"
                    icon={getIcon('google')}
                    name="Google My Business"
                    linkStatus={getIntegrationStatus('google')}
                    linkText="Google My Business verknüpfen"
                    data={getIntegrationData('google')}
                    on:clicked={onIntegrationClicked}
            />

            <IntegrationPreview
                    id="facebook"
                    icon={getIcon('facebook')}
                    name="Facebook"
                    linkStatus={getIntegrationStatus('facebook')}
                    linkText="Facebook verknüpfen"
                    data={getIntegrationData('facebook')}
                    available={false}
                    on:clicked={onIntegrationClicked}
            />

        </div>

        {#if showButton}

            <button class="btn">

                <span>Abschliessen</span>

            </button>

        {/if}

    </form>

{/if}

{#if currentView === 'tripadvisor'}

    <Tripadvisor
            data={getIntegrationData('tripadvisor')}
            on:selected={onTripadvisorSelected}
            on:closed={onClosed}
            on:deleted={onIntegrationDeleted} />

{/if}

{#if currentView === 'google'}

    <Google
            propertyId={propertyId}
            data={getIntegrationData('google')}
            on:selected={onGoogleSelected}
            on:closed={onClosed}
            on:deleted={onIntegrationDeleted} />

{/if}

{#if currentView === 'facebook'}

    <Facebook
            propertyId={propertyId}
            data={getIntegrationData('facebook')}
            on:selected={onFacebookSelected}
            on:closed={onClosed}
            on:deleted={onIntegrationDeleted} />

{/if}


<style>

    .integrations {
        margin-top: 4.72vh;
    }

    #formtitle {
        margin-bottom: 0.64vh;
        font-family: 'Raleway', sans-serif;
        font-size: 1.85vh;
        font-weight: 500;
    }

    #formsubtitle {
        font-family: 'Raleway', sans-serif;
        font-size: 1.48vh;
    }

    #error {
        width: 27.6vh;
        padding: 1.78vh;
        margin-top: 2vh;
        font-size: 1.8vh;
    }

    :global(.integration) {
        margin-bottom: 2.12vh;
    }

    :global(.integration:last-child) {
        margin-bottom: 0;
    }

    #integrationsform button {
        width: 31.15vh;
        padding: 1.42vh;
        margin-top: 4.16vh;
        font-size: 1.78vh;
    }

</style>
